module.exports = __webpack_public_path__ + "media/images/mobile/service/bg-002cc4681752beb35d21cb9275143cdb.jpg";